// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 5015) return "static/chunks/5015-8b0d11102466aa29.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1160":"a77c0a214e6cf3bb","3509":"e01e052f34366202","4042":"47e944bdf4102a5f","4856":"b1ffd4dc92bdee10","5480":"89d60213683f4730","7311":"f9e1f1e1cc3666b3"}[chunkId] + ".js";
};